module.exports = __webpack_public_path__ + "static/assets/7d328a5f134764e91aae5c7443b09e29.gif";